























import { defineComponent } from "@vue/composition-api";
import { StoryView } from "@scrile/api-provider/dist/api/StoriesProvider";
import useAuthUser from "@/hooks/useAuthUser";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseAvatar from "@/components/BaseAvatar";
import BaseIconButton from "@/components/BaseIconButton";

export default defineComponent({
  name: "StoryStatisticViewsItem",
  components: { BaseIconButton, BaseAvatar, BaseIcon },
  props: {
    item: { type: Object as () => StoryView, required: true },
  },
  setup(_, { root, emit }) {
    const { authUserStrict } = useAuthUser();
    const goToMessage = (userId: string) => {
      emit("close");
      root.$router.push({ name: "messages", params: { userId } });
    };
    return { authUserStrict, goToMessage };
  },
});
